import React from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/components/singleSlideStyle';
import { makeStyles } from '@material-ui/core';
import { BodyM, CaptionBold, HeadingSBold } from 'components/Typography/Typography';
import Button from 'components/CustomButtons/Button';
import { translate } from 'components/Translation';
import classNames from 'classnames';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import CheckBox from '@material-ui/icons/CheckBox';
import UnlimitedIcon from '@material-ui/icons/AllInclusive';
import CustomLinearProgress from 'components/CustomLinearProgress/CustomLinearProgress';

// @ts-ignore
const useStyles = makeStyles(styles);

interface ISingleSlideProps {
	tab: types.newServices.IServicePickerTab;
	width: number;
	firstSlide: boolean;
	lastSlide: boolean;
	onClick: () => void;
	popularColor: types.newServices.servicePickerColor;
	selectedTabColor?: types.newServices.servicePickerColor;
	selected: boolean;
	transparent: boolean;
}

const SingleSlide = ({
	tab,
	width,
	firstSlide,
	lastSlide,
	popularColor,
	selected,
	onClick,
	transparent,
	selectedTabColor,
}: ISingleSlideProps) => {
	const { header } = tab;
	const classes = useStyles({ numberOfCells: tab.numberOfCells, headerHeight: header.height });
	const singleSlideWrapperClasses = classNames(classes.singleSlideWrapper, {
		[classes.lastSlide]: lastSlide,
		[classes.firstSlide]: firstSlide,
		[classes.selectedSlideWrapper]: selected,
		[classes.transparent]: transparent,
	});

	const headerWrapperClasses = classNames(classes.headerWrapper, {
		[classes[`${popularColor}CurrentPlanHeader`]]: tab.currentPlan,
		[classes[`${selectedTabColor}SelectedHeader`]]: selected,
	});

	const selectTab = () => {
		if (!tab.disabled) {
			onClick();
		}
	};

	return (
		<div className={singleSlideWrapperClasses} style={{ width: width, minWidth: width }} onClick={selectTab}>
			<div className={headerWrapperClasses}>
				<ConditionalRender
					show={!!tab.currentPlan}
					onTrue={() => (
						<div className={classes.currentPlanWrapper}>
							<CaptionBold color="primary-dark" disableMargin>
								{translate('current.plan')}
							</CaptionBold>
						</div>
					)}
				/>
				<ConditionalRender
					show={!!header.superscription}
					onTrue={() => (
						<BodyM color="secondary-dark" disableMargin>
							{header.superscription}
						</BodyM>
					)}
				/>
				<HeadingSBold dir={'auto'} color="primary-dark" disableMargin>
					{header.title}
				</HeadingSBold>
				<ConditionalRender
					show={!!header.subtitle}
					onTrue={() => (
						<BodyM color="secondary-dark" disableMargin>
							{header.subtitle}
						</BodyM>
					)}
				/>
				<ConditionalRender
					show={!!header.unlimited}
					onTrue={() => (
						<div className={classes.unlimitedWrapper}>
							<UnlimitedIcon />
						</div>
					)}
				/>
				<ConditionalRender
					show={!!header.progress}
					onTrue={() => (
						<div className={classes.progressBarWrapper}>
							<CustomLinearProgress
								variant="determinate"
								color={'warning'}
								value={header.progress || 0}
								className={classes.linearProgress}
							/>
						</div>
					)}
				/>
			</div>
			<div
				className={classNames(classes.bodyWrapper, {
					[classes.bodyWrapperSelected]: selected,
				})}
			>
				{tab.column}
			</div>
			<div className={classNames(classes.buttonWrapper, classes.grayBackground)}>
				<Button
					color="tertiary-light"
					withIcon={selected}
					fullWidth
					disabled={!!tab.disabled}
					data-testId="selectNamaPlan"
				>
					<>
						<ConditionalRender
							show={selected}
							onTrue={() => (
								<>
									<CheckBox />
									{translate('selected')}
								</>
							)}
							onFalse={() => <>{translate('select')}</>}
						/>
					</>
				</Button>
			</div>
		</div>
	);
};

export default SingleSlide;
